import React, { PureComponent } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import NoData from "../../../../../Dashboard/Charts/NoData/NoData";
import { numberWithCommas } from "../../../../../Dashboard/utils";

class RepliesOverTimeChart extends PureComponent {
    constructor(props) {
        super(props);

        this.chartComponent = React.createRef();
    }

    componentDidMount() {
        // if (!this.props.isTWPage) {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent.current?.chart?.setSize(null, null);
                this.chartComponent.current?.chart?.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef?.current) {
            this.ro.observe(this.props.widgetContainerRef?.current);
        }
        // }
    }

    componentWillUnmount() {
        // if (!this.props.isTWPage) {
        this.ro.disconnect();
        // }
    }

    getOptions = () => {
        if (this.props.graph_type == "line") return this.getLineOptions();
        else return this.getBarOptions();
    };

    getLineOptions = () => {
        let x = this.props.data;
        const height = this.props.isTWPage ? "338px" : null;
        const legendAlign = this.props.isTWPage ? "right" : "center";

        const pageViewConfig = {
            plotOptions: {
                series: {
                    cursor: "pointer",
                    stacking: null,
                    marker: {
                        enabled: true,
                        radius: 2,
                    },
                },
            },
            chart: {
                type: "spline",
                className: "skiptranslate",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                height,
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No Data.",
            },
            legend: {
                enabled: this.props.showLegend,
                alignColumns: false,
                align: legendAlign,
            },
            noData: {
                position: {
                    align: "center",
                },
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                // min: 0,
                allowDecimals: false,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
            },
            tooltip: {
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${moment(this.x).startOf("day").format("LLLL")}</span>
                    <br/><span>${this.series.name}: <b>${numberWithCommas(this.y)}</b></span>`;
                },
            },
            series: [{ color: "turquoise", name: "Replies", data: x?.data ? x.data : [] }],
            time: {
                useUTC: false,
            },
        };

        return pageViewConfig;
    };

    getBarOptions = () => {
        let x = this.props.data;
        const height = this.props.isTWPage ? "338px" : null;
        const legendAlign = this.props.isTWPage ? "right" : "center";

        const pageViewColumnConfig = {
            plotOptions: {
                series: {
                    cursor: "pointer",
                    stacking: "normal",
                },
            },
            chart: {
                type: "column",
                height,
            },
            credits: {
                enabled: false,
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                // min: 0,
                allowDecimals: false,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
            },
            lang: {
                noData: "No Data.",
            },
            tooltip: {
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${moment(this.x).startOf("day").format("LLLL")}</span>
                    <br/> <span>${this.series.name}: <b>${numberWithCommas(this.y)}</b></span>`;
                },
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                    paddingTop: "10px",
                    color: "#1f2e3d",
                },
                alignColumns: false,
                paddingTop: 18,
                align: legendAlign,
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#1f2e3d",
                    fontFamily: "'Roboto', sans-serif",
                },
                position: {
                    align: "center",
                },
            },
            series: [{ color: "turquoise", name: "Replies", data: x?.data ? x.data : [] }],
            time: {
                useUTC: false,
            },
        };

        return pageViewColumnConfig;
    };

    render() {
        return (
            <>
                {!this.props.isNoData() && !this.props.error ? (
                    <>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOptions()}
                            ref={this.chartComponent}
                            containerProps={!this.props.isTWPage && { style: { width: "100%", height: "calc(100% - 20px)" } }}
                        />
                    </>
                ) : (
                    <NoData />
                )}
            </>
        );
    }
}

export default RepliesOverTimeChart;
